import styles from './index.less';
import { Button, Divider, Typography } from 'react-vant';
import { useNavigate, useModel } from '@umijs/max';

import { AssetDetailEnum } from '@/pages/Mine/config';
import { queryOwnerDetail } from '@/service/house';
import { useEffect } from 'react';
import { useSafeState } from 'ahooks';
import { OwnerAssetsCountType } from '@/pages/Mine/interface';

const PersonAsset = () => {
  const navigate = useNavigate();
  const [ownerAssetsCountDetail, setOwnerAssetsCountDetail] = useSafeState<
    OwnerAssetsCountType | undefined
  >(undefined);
  const { defaultRoom, ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
      ownerInformation: model.ownerInformation,
    }),
  );

  const jumpToAssetDetail = (type: string) => {
    navigate('/assetDetail', {
      state: {
        type: type,
      },
    });
  };

  const loadOwnerDetail = () => {
    queryOwnerDetail(ownerInformation?.sequenceNbr).then((res) => {
      if (res?.code === 200) {
        if (res?.data) {
          setOwnerAssetsCountDetail(res?.data);
        }
      }
    });
  };

  useEffect(() => {
    loadOwnerDetail();
  }, []);

  return (
    <div className={styles.container}>
      <Typography.Title level={5}>
        当前：{defaultRoom?.roomCode}
      </Typography.Title>
      {/*<div className={styles.title}></div>*/}
      <div className={styles.content}>
        <div>
          <section>
            <img src={require('@/assets/home/hg.png')} alt={'home'} />
            <div>
              <Typography.Title level={6}>房屋管理</Typography.Title>
              <Typography.Text>
                数量：{ownerAssetsCountDetail?.room}
              </Typography.Text>
            </div>
          </section>
          <Button
            onClick={() => jumpToAssetDetail(AssetDetailEnum.HOUSE)}
            plain
            round
            size={'small'}
            type={'primary'}
          >
            查看更多
          </Button>
        </div>
        <Divider />
        <div>
          <section>
            <img src={require('@/assets/home/pg.png')} alt={'home'} />
            <div>
              <Typography.Title level={6}>车位管理</Typography.Title>
              <Typography.Text>
                数量：{ownerAssetsCountDetail?.park}
              </Typography.Text>
            </div>
          </section>
          <Button
            onClick={() => jumpToAssetDetail(AssetDetailEnum.PARKING_LOT)}
            plain
            round
            size={'small'}
            type={'primary'}
          >
            查看更多
          </Button>
        </div>
        <Divider />
        <div>
          <section>
            <img src={require('@/assets/home/cg.png')} alt={'home'} />
            <div>
              <Typography.Title level={6}>车辆管理</Typography.Title>
              <Typography.Text>
                数量：{ownerAssetsCountDetail?.car}
              </Typography.Text>
            </div>
          </section>
          <Button
            onClick={() => jumpToAssetDetail(AssetDetailEnum.CARPORT)}
            plain
            round
            size={'small'}
            type={'primary'}
          >
            查看更多
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PersonAsset;
